export enum WeekNumber {
  'Day Of Month' = -1,
  First = 0,
  Second = 1,
  Third = 2,
  Fourth = 3,
  Penultimate = 4,
  Last = 5
}
